import { AuthService } from '../service/auth.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonToastService } from '../../shared/services/common-toast.service';
import { MESSAGE_CATEGORY_CONSTATNS, MESSAGE_CONSTATNS } from '../../shared/constants/constant';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService,private toastr: CommonToastService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        
        if (err.status === 401) {
        this.toastr.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR,MESSAGE_CATEGORY_CONSTATNS.UNAUTHORIZEd_ACCESS, MESSAGE_CONSTATNS.LOGIN_TO_CONTINUE);
        this.authenticationService.logout();
        }
        // Feedback #26.2: the API now answers a missing module permission with 403 instead of 401,
        // so a permission gap no longer signs the user out. Say what happened - otherwise the
        // request fails silently on any screen that has no error handling of its own.
        if (err.status === 403) {
        this.toastr.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.UNAUTHORIZEd_ACCESS,
          err?.error?.error || 'You do not have permission to perform this action. Please contact your administrator.');
        }
        return throwError(err);
      })
    );
  }
}
